/* eslint-disable @typescript-eslint/no-unused-vars */
import { Grid, MenuItem } from '@material-ui/core';
import {
  getClasses
} from '@webapps/business';
import {
  Button,
  FormikAutocompletePx,
  FormikTextField,
  useAuth,
  useQuery,
  TextField,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

const FiltersStudents = ({ formik = {} }) => {
  const {
    classes,
    css,
    theme: { spacing },
  } = useStyles(styles);
  const { idUser } = useAuth();

  const [page, setPage] = useState(1);

  const { data: { content: allClasses = [], totalClasse } = {} } =
    useQuery(getClasses, {
      key: ['classesHAAAAAA2<QAAAAAAAAAAA', page + idUser],
      variables: {
        keyword,
        id: idUser,
        page: page - 1,
        size: 12,
      },
    });

  console.log("allClasses", allClasses);


  const resetFilter = () => {
    formik.resetForm();
    formik.handleSubmit();
  };


  return (
    <Grid container spacing={2}>
      <Grid className={classes.grid} item xs={12}>
        <FormikAutocompletePx
          formik={formik}
          fullWidth
          getOptionLabel={(option) => option.label || ''}
          label="Classe"
          name="classes"
          options={allClasses}
          pathValue="id"
          value={allClasses.find((classe) => classe.id === formik.values.classes)}
        />
      </Grid>
      <Grid className={classes.grid} item xs={12}>
        <Button
          color="primary"
          fullWidth
          onClick={() => {
            formik.handleSubmit();
          }}
          variant="contained"
          className={css({ borderRadius: '400px' })}
        >
          <FormattedMessage id="btnSearch" />
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button
          className={css({ backgroundColor: 'white' })}
          color="primary"
          fullWidth
          onClick={resetFilter}
          variant="outlined"
        >
          Réinitialiser
        </Button>
      </Grid>
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  grid: {
    marginBottom: '10px',
  },
});

FiltersStudents.propTypes = {
  formik: PropTypes.object,
};

export default FiltersStudents;
